/**
 * DS Blog Newsletter – Submit Spinner (UX only)
 * No AJAX — form submits natively via Shopify {% form 'customer' %}.
 * Shopify handles hCaptcha, validation, and redirect.
 * GA4 tracking is handled via inline <script> in Liquid on success.
 * V2.1 – 2026-03-30 (Native submission, hCaptcha compatible)
 */
(function() {
  'use strict';

  document.querySelectorAll('[data-ds-blog-nl]').forEach(function(container) {
    var formEl = container.querySelector('form');
    var submitBtn = container.querySelector('[data-ds-blog-nl-submit]');
    var btnText = container.querySelector('[data-ds-blog-nl-btn-text]');

    if (!formEl || !submitBtn) return;

    formEl.addEventListener('submit', function() {
      submitBtn.disabled = true;
      if (btnText) {
        btnText.textContent = '';
        var spinner = document.createElement('span');
        spinner.className = 'ds-blog-nl__spinner';
        submitBtn.appendChild(spinner);
      }
    });
  });
})();
